import { HomePhoneOrder } from "../../../../../types/homePhone";
import type { DeviceFilter } from "../types";

export const getOrderStage = (order: HomePhoneOrder): DeviceFilter => {
  const combined =
    `${order.status} ${order.paymentStatus} ${order.activationStatus}`.toLowerCase();

  if (combined.includes("activated") || combined.includes("active"))
    return "active";
  if (combined.includes("deliver") || combined.includes("complete"))
    return "delivered";
  if (combined.includes("ship")) return "shipped";
  return "in-process";
};
